import {
  FileType,
  getOrderFirstProduct,
  ItemType,
  PickupStatus,
  type File,
  type Order,
  type Pickup,
  type Product,
} from "@jasper/shared";

// An order can be enriched later on with new full denture products (next appointment):
// selecting the last one provides a better UX for the dentist.
export const getInitialSelectedProduct = (order: Order): Product | null => {
  const fullDentureProducts = order.products.filter(
    product => product.productType === ItemType.FULL_DENTURE
  );
  if (fullDentureProducts.length > 1) {
    return fullDentureProducts[fullDentureProducts.length - 1];
  }
  return getOrderFirstProduct(order);
};

// For PAC RDV2 orders, show the newest product first (higher rdvNumber first).
export const getDisplayedProducts = (products: Product[]): Product[] => {
  const hasPacRdv2 = products.some(
    product => (product.removableItem?.[0]?.rdvNumber ?? 0) > 1
  );
  return hasPacRdv2 ? [...products].reverse() : products;
};

export const getActivePickups = (order: Order): Pickup[] =>
  (order.pickup ?? []).filter(pickup => pickup?.status === PickupStatus.ACTIVE);

export const getLatestPickupFile = (files: File[]): File | null =>
  files
    .filter(file => file.fileType === FileType.PICKUP)
    .toSorted(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )[0] ?? null;
